import React from 'react'

function Ads() {
  return (
    
         <div className='sticky top-20'>


         <h3 className='px-6 py-2   rounded'>Advertisement: </h3>
         <div className='h-24 mx-auto bg-slate-50 w-11/12 my-2'>
            </div>
            <div className='h-24 mx-auto bg-slate-50 w-11/12 my-2'>
            </div>
            <div className='h-24 mx-auto bg-slate-50 w-11/12 my-2'>
            </div>
            <div className='h-24 mx-auto bg-slate-50 w-11/12 my-2'>
            </div>

          </div>
        
    
  )
}

export default Ads
